import { AnimateProvider } from '@features/animations/components/animate-provider';
import { AnimatedFadeComponent } from '@features/animations/components/animated-fade-component';
import { Avatar } from '@features/shared/components/avatar';
import { Container } from '@features/shared/components/container';
import { Link } from '@features/shared/components/link';
import { useCurrentMatch } from '@features/shared/hooks/use-current-match';
import {
  HomePage,
  ItemCatalogPage,
  ProfilePage,
  QRCodePage,
} from '@features/shared/routes';
import { cn } from '@features/shared/utils/cn';
import BookOpenIcon from '@heroicons/react/24/outline/BookOpenIcon';
import HomeIcon from '@heroicons/react/24/solid/HomeIcon';
import QrCodeIcon from '@heroicons/react/24/solid/QrCodeIcon';
import { useSearchParams } from 'react-router-dom';

export type NavbarProps = {
  title?: string;
};

export function Tabbar() {
  const match = useCurrentMatch();
  const [searchParams] = useSearchParams();

  const shouldShowTabbar =
    searchParams.has('h', '1') ||
    match === '/' ||
    ['/list', '/merchant'].some((path) => match?.startsWith(path));

  return (
    <AnimateProvider>
      {shouldShowTabbar ? (
        <AnimatedFadeComponent key="tabbar">
          <Container
            as="nav"
            className={cn(
              'w-screen h-14 z-50',
              'flex flex-col justify-center',
              'border-t-gray-200 border-t bg-white',
            )}
          >
            <div className="flex flex-row items-center relative justify-evenly">
              <Link
                to="/"
                preload={HomePage.preload}
                className={cn(
                  shouldShowTabbar
                    ? 'pointer-events-none'
                    : 'pointer-events-auto',
                )}
              >
                <HomeIcon className="size-6 text-l-green-400" />
              </Link>
              <Link to="/item-catalog" preload={ItemCatalogPage.preload}>
                <BookOpenIcon className="size-6" />
              </Link>
              <Link to="/qrcode" preload={QRCodePage.preload}>
                <QrCodeIcon className="size-6" />
              </Link>
              <Link to="/profile" preload={ProfilePage.preload}>
                <Avatar className="size-8" />
              </Link>
            </div>
          </Container>
        </AnimatedFadeComponent>
      ) : null}
    </AnimateProvider>
  );
}
